<template src="./template.html"></template>
<script>
export default {
  name: 'DriverNewForm',
  props: {
    vehicles: Array,
    users: Array,
    company_uuid: String,
    value: Array,
  },
  data() {
    return {
      selectedDriversList: this.value?.length > 0 ? this.value : [],
    }
  },
  computed: {
    availableVehicles: function () {
      let excludeList = this.selectedDriversList.map(dl => dl.vehicle).filter(v => v != null)
      let temp = this.vehicles.filter(x => !excludeList.includes(x))
      this.sendDriversList()
      return temp
    },
    availableUsers: function () {
      let excludeList = this.selectedDriversList.map(dl => dl.user).filter(v => v != null)
      this.sendDriversList()
      return this.users.map(u => u.user).filter(u => !excludeList.includes(u))
    },
  },
  methods: {
    async createDriver() {
      this.selectedDriversList.push({
        vehicle: null,
        user: null,
      })
    },
    deleteDriver(index) {
      this.selectedDriversList.splice(index, 1)
      this.sendDriversList()
    },
    sendDriversList() {
      this.$emit('input', this.selectedDriversList)
    },
  },
}
</script>
<style lang="scss" src="./style.scss" scoped />
